import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { transformRESTFloatToSDKFloat } from '@wix/sdk-runtime/transformations/float';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveWixEcomEcommerceSettingsV1EcommerceSettingsServiceUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    _: [
      {
        srcPath: '/_api/ecommerce-settings',
        destPath: '',
      },
    ],
    'editor._base_domain_': [
      {
        srcPath: '/_api/ecommerce-settings',
        destPath: '',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/_api/ecommerce-settings',
        destPath: '',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/_api/ecommerce-settings',
        destPath: '',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/_api/ecommerce-settings',
        destPath: '',
      },
    ],
    'editor.wixapps.net': [
      {
        srcPath: '/_api/ecommerce-settings',
        destPath: '',
      },
    ],
    'www._base_domain_': [
      {
        srcPath: '/_api/ecommerce-settings',
        destPath: '',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/_api/ecommerce-settings',
        destPath: '',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_ecom_ecommerce-settings';

/** Retrieves site eCommerce settings. */
export function getEcommerceSettings(
  payload: object
): RequestOptionsFactory<any> {
  function __getEcommerceSettings({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.ecom.v1.ecommerce_settings',
      method: 'GET' as any,
      methodFqn:
        'wix.ecom.ecommerce_settings.v1.EcommerceSettingsService.GetEcommerceSettings',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixEcomEcommerceSettingsV1EcommerceSettingsServiceUrl({
        protoPath: '/v1/ecommerce-settings',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'ecommerceSettings.checkout.createdDate' },
              { path: 'ecommerceSettings.checkout.updatedDate' },
              {
                path: 'ecommerceSettings.checkout.checkoutBrand.header.logo.image.urlExpirationDate',
              },
              {
                path: 'ecommerceSettings.checkout.checkoutBrand.header.backgroundFill.image.urlExpirationDate',
              },
              {
                path: 'ecommerceSettings.checkout.checkoutBrand.mainSection.formBackgroundFill.image.urlExpirationDate',
              },
              {
                path: 'ecommerceSettings.checkout.checkoutBrand.mainSection.summaryBackgroundFill.image.urlExpirationDate',
              },
              {
                path: 'ecommerceSettings.checkout.checkoutBrand.footer.backgroundFill.image.urlExpirationDate',
              },
            ],
          },
          {
            transformFn: transformRESTFloatToSDKFloat,
            paths: [
              {
                path: 'ecommerceSettings.checkout.checkoutBrand.header.logo.image.focalPoint.x',
              },
              {
                path: 'ecommerceSettings.checkout.checkoutBrand.header.logo.image.focalPoint.y',
              },
              {
                path: 'ecommerceSettings.checkout.checkoutBrand.header.backgroundFill.image.focalPoint.x',
              },
              {
                path: 'ecommerceSettings.checkout.checkoutBrand.header.backgroundFill.image.focalPoint.y',
              },
              {
                path: 'ecommerceSettings.checkout.checkoutBrand.mainSection.formBackgroundFill.image.focalPoint.x',
              },
              {
                path: 'ecommerceSettings.checkout.checkoutBrand.mainSection.formBackgroundFill.image.focalPoint.y',
              },
              {
                path: 'ecommerceSettings.checkout.checkoutBrand.mainSection.summaryBackgroundFill.image.focalPoint.x',
              },
              {
                path: 'ecommerceSettings.checkout.checkoutBrand.mainSection.summaryBackgroundFill.image.focalPoint.y',
              },
              {
                path: 'ecommerceSettings.checkout.checkoutBrand.footer.backgroundFill.image.focalPoint.x',
              },
              {
                path: 'ecommerceSettings.checkout.checkoutBrand.footer.backgroundFill.image.focalPoint.y',
              },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __getEcommerceSettings;
}
